import { render, staticRenderFns } from "./shopDetails.vue?vue&type=template&id=4aa2961e&scoped=true"
import script from "./shopDetails.vue?vue&type=script&lang=js"
export * from "./shopDetails.vue?vue&type=script&lang=js"
import style0 from "./shopDetails.vue?vue&type=style&index=0&id=4aa2961e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa2961e",
  null
  
)

export default component.exports